import React from "react";

export const LazyMeetingThreadPopupBridge = React.lazy(
    () =>
        import(
            /* webpackChunkName: "MeetingThreadPopup" */ "./MeetingThreadPopup"
        )
);
